import { stats } from '@fiverr-private/obs';
import { APP_NAME } from '../../../../../configuration/constants';

export const metric = stats.prefix(`services.${APP_NAME}`);
